import Cookies from 'js-cookie'

export function getDecodeUser() {
  const enc = Cookies.get('user')
  if (enc) {
    const dec = JSON.parse(atob(enc))
    const user = dec
    return { ...user }
  }
  return
}
